<app-header></app-header>

<div class="container my-3 wrap">

 <router-outlet></router-outlet>

</div>

<!--<app-footer></app-footer>-->
